import { render, staticRenderFns } from "./ColorCategory.vue?vue&type=template&id=4777bb12&"
import script from "./ColorCategory.vue?vue&type=script&lang=js&"
export * from "./ColorCategory.vue?vue&type=script&lang=js&"
import style0 from "./ColorCategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports